import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

const TZ_DEFAULT = "America/Los_Angeles";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);

const startDate = dayjs().tz(TZ_DEFAULT).startOf("day").utc();
const endDate = dayjs().tz(TZ_DEFAULT).endOf("day").utc();

export { dayjs, startDate, endDate };
